import { Admin } from "../../domain/model/Admin";
import { Attachment } from "../../domain/model/Attachment";
import {
  Auth,
  AccessToken,
  Message,
  MessageAndIdModel,
} from "../../domain/model/Auth";
import { Category } from "../../domain/model/Category";
import { Question, Answer } from "../../domain/model/Question";
import { AllStats, QuestionAnswerCount } from "../../domain/model/Stats";
import { ApiService } from "../api/ApiService";
import { Response } from "../api/Response";
import { API_ENDPOINTS } from "../constant/ApiConstants";
import NetworkApi from "./NetworkApi";

export default class NetworkApiImpl implements NetworkApi {
  apiService: ApiService;

  constructor(apiService: ApiService) {
    this.apiService = apiService;
  }
  login(auth: Auth): Promise<Response<AccessToken>> {
    return this.apiService.post<AccessToken>(API_ENDPOINTS.LOGIN, auth);
  }
  uploadFile(fileFormData: FormData): Promise<Response<Attachment>> {
    return this.apiService.post<Attachment>(
      API_ENDPOINTS.UPLOAD_FILE,
      fileFormData,
    );
  }

  // admin
  getAdminInfo(): Promise<Response<Admin>> {
    return this.apiService.get<Admin>(API_ENDPOINTS.ADMINS);
  }
  updateAdminInfo(admin: Admin): Promise<Response<Message>> {
    return this.apiService.put<Message>(API_ENDPOINTS.ADMINS, admin);
  }

  // stats
  getAllStats(): Promise<Response<AllStats>> {
    return this.apiService.get<AllStats>(API_ENDPOINTS.STATS);
  }
  getQuestionsAndAnswersStats(): Promise<Response<QuestionAnswerCount>> {
    return this.apiService.get<QuestionAnswerCount>(
      API_ENDPOINTS.STATS + API_ENDPOINTS.QUESTIONS_ANSWERS,
    );
  }

  // catgories
  createCategory(category: Category): Promise<Response<Message>> {
    return this.apiService.post<Message>(API_ENDPOINTS.CATEGORIES, category);
  }
  getCategories(): Promise<Response<Array<Category>>> {
    return this.apiService.get<Array<Category>>(API_ENDPOINTS.CATEGORIES);
  }
  getCategory(id: string): Promise<Response<Category>> {
    return this.apiService.get<Category>(`${API_ENDPOINTS.CATEGORIES}/${id}`);
  }
  updateCategory(category: Category): Promise<Response<Message>> {
    return this.apiService.put<Message>(
      `${API_ENDPOINTS.CATEGORIES}/${category._id}`,
      category,
    );
  }
  deleteCategory(id: string): Promise<Response<Message>> {
    return this.apiService.delete<Message>(`${API_ENDPOINTS.CATEGORIES}/${id}`);
  }

  // questions
  createQuestion(question: Question): Promise<Response<MessageAndIdModel>> {
    return this.apiService.post<MessageAndIdModel>(
      API_ENDPOINTS.QUESTIONS,
      question,
    );
  }
  getQuestions(
    skip?: number,
    limit?: number,
  ): Promise<Response<Array<Question>>> {
    var url = `${API_ENDPOINTS.QUESTIONS}`;
    if (limit !== undefined) {
      url += `?limit=${limit}`;
      if (skip !== undefined) {
        url += `&skip=${skip}`;
      }
    }
    return this.apiService.get<Array<Question>>(url);
  }
  getQuestion(id: string): Promise<Response<Question>> {
    return this.apiService.get<Question>(`${API_ENDPOINTS.QUESTIONS}/${id}`);
  }
  filterQuestionsBy(queryString: string): Promise<Response<Array<Question>>> {
    return this.apiService.get<Array<Question>>(
      `${API_ENDPOINTS.QUESTIONS}${API_ENDPOINTS.FILTER}?${queryString}`,
    );
  }
  updateQuestion(question: Question): Promise<Response<Message>> {
    return this.apiService.put<Message>(
      `${API_ENDPOINTS.QUESTIONS}/${question._id}`,
      question,
    );
  }
  deleteQuestion(id: string): Promise<Response<Message>> {
    return this.apiService.delete<Message>(`${API_ENDPOINTS.QUESTIONS}/${id}`);
  }

  deleteQuestionAttachment(id: string): Promise<Response<Message>> {
    return this.apiService.delete<Message>(
      `${API_ENDPOINTS.QUESTIONS}/${id}${API_ENDPOINTS.ATTACHMENT}`,
    );
  }

  // answers
  createAnswer(answer: Answer): Promise<Response<Message>> {
    return this.apiService.post<Message>(API_ENDPOINTS.ANSWERS, answer);
  }
  getAnswers(): Promise<Response<Array<Answer>>> {
    return this.apiService.get<Array<Answer>>(API_ENDPOINTS.ANSWERS);
  }
  getAnswer(id: string): Promise<Response<Answer>> {
    return this.apiService.get<Answer>(`${API_ENDPOINTS.ANSWERS}/${id}`);
  }
  getAnswerByQuestionId(id: string): Promise<Response<Answer>> {
    return this.apiService.get<Answer>(
      `${API_ENDPOINTS.ANSWERS}${API_ENDPOINTS.QUESTION_ID}/${id}`,
    );
  }
  getAnswersByListOfQuestionsId(
    questionsId: string,
  ): Promise<Response<Array<Answer>>> {
    return this.apiService.get<Array<Answer>>(
      `${API_ENDPOINTS.ANSWERS}${API_ENDPOINTS.QUESTION_ID}?questions_ids=${questionsId}`,
    );
  }
  updateAnswer(answer: Answer): Promise<Response<Message>> {
    return this.apiService.put<Message>(
      `${API_ENDPOINTS.ANSWERS}/${answer._id}`,
      answer,
    );
  }
  deleteAnswer(id: string): Promise<Response<Message>> {
    return this.apiService.delete<Message>(`${API_ENDPOINTS.ANSWERS}/${id}`);
  }
  deleteAnswerByQuestionId(id: string): Promise<Response<Message>> {
    return this.apiService.delete<Message>(
      `${API_ENDPOINTS.ANSWERS}${API_ENDPOINTS.QUESTION_ID}/${id}`,
    );
  }
  deleteAnswerAttachment(id: string): Promise<Response<Message>> {
    return this.apiService.delete<Message>(
      `${API_ENDPOINTS.ANSWERS}/${id}${API_ENDPOINTS.ATTACHMENT}`,
    );
  }
}
